import { Contract } from '@features/contracts/models/contract.model';
import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';

export class ShipmentPrices extends Model {
  @Expose() fleetSpotPrice: number;
  @Expose() customerSpotPrice: number;
  @Type(() => Contract)
  @Expose()
  costContract: Contract;
  @Expose()
  priceContract: Contract;
  @Expose()
  costUpdatedAt: Date;
  @Expose()
  priceUpdatedAt: Date;
}
